// @generated by protoc-gen-es v1.2.0 with parameter "target=js+dts"
// @generated from file wavin/aqora/v2/command.proto (package wavin.aqora.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";

/**
 * @generated from message wavin.aqora.v2.Command
 */
export const Command = proto3.makeMessageType(
  "wavin.aqora.v2.Command",
  () => [
    { no: 1, name: "resource_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "enable_auto_mode", kind: "message", T: EnableAutoModeCommand, oneof: "payload" },
    { no: 3, name: "open_valve", kind: "message", T: OpenValveCommand, oneof: "payload" },
    { no: 4, name: "close_valve", kind: "message", T: CloseValveCommand, oneof: "payload" },
    { no: 5, name: "set_valve_height", kind: "message", T: SetValveHeightCommand, oneof: "payload" },
    { no: 6, name: "open_tap", kind: "message", T: OpenTapCommand, oneof: "payload" },
    { no: 7, name: "close_tap", kind: "message", T: CloseTapCommand, oneof: "payload" },
    { no: 8, name: "request_measurement", kind: "message", T: RequestMeasurementCommand, oneof: "payload" },
    { no: 9, name: "maintenance_mode", kind: "message", T: MaintenanceMode, oneof: "payload" },
      {no: 10, name: "push_device_settings", kind: "message", T: PushDeviceSettingsCommand, oneof: "payload"},
      {no: 11, name: "set_pump_command", kind: "message", T: SetPumpCommand, oneof: "payload"},
      {no: 12, name: "device_specific_command", kind: "message", T: DeviceSpecificCommand, oneof: "payload"},
  ],
);

/**
 * @generated from message wavin.aqora.v2.EnableAutoModeCommand
 */
export const EnableAutoModeCommand = proto3.makeMessageType(
  "wavin.aqora.v2.EnableAutoModeCommand",
  [],
);

/**
 * @generated from message wavin.aqora.v2.OpenValveCommand
 */
export const OpenValveCommand = proto3.makeMessageType(
  "wavin.aqora.v2.OpenValveCommand",
  [],
);

/**
 * @generated from message wavin.aqora.v2.CloseValveCommand
 */
export const CloseValveCommand = proto3.makeMessageType(
  "wavin.aqora.v2.CloseValveCommand",
  [],
);

/**
 * @generated from message wavin.aqora.v2.SetValveHeightCommand
 */
export const SetValveHeightCommand = proto3.makeMessageType(
  "wavin.aqora.v2.SetValveHeightCommand",
  () => [
    { no: 1, name: "target_valve_height", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * @generated from message wavin.aqora.v2.OpenTapCommand
 */
export const OpenTapCommand = proto3.makeMessageType(
  "wavin.aqora.v2.OpenTapCommand",
  [],
);

/**
 * @generated from message wavin.aqora.v2.CloseTapCommand
 */
export const CloseTapCommand = proto3.makeMessageType(
  "wavin.aqora.v2.CloseTapCommand",
  [],
);

/**
 * @generated from message wavin.aqora.v2.RequestMeasurementCommand
 */
export const RequestMeasurementCommand = proto3.makeMessageType(
  "wavin.aqora.v2.RequestMeasurementCommand",
  [],
);

/**
 * @generated from message wavin.aqora.v2.MaintenanceMode
 */
export const MaintenanceMode = proto3.makeMessageType(
  "wavin.aqora.v2.MaintenanceMode",
  () => [
    { no: 1, name: "state", kind: "enum", T: proto3.getEnumType(MaintenanceMode_State) },
  ],
);

/**
 * @generated from enum wavin.aqora.v2.MaintenanceMode.State
 */
export const MaintenanceMode_State = proto3.makeEnum(
  "wavin.aqora.v2.MaintenanceMode.State",
  [
    {no: 0, name: "STATE_MAINTENANCE_MODE_UNSPECIFIED", localName: "MAINTENANCE_MODE_UNSPECIFIED"},
    {no: 1, name: "STATE_MAINTENANCE_MODE_ON", localName: "MAINTENANCE_MODE_ON"},
    {no: 2, name: "STATE_MAINTENANCE_MODE_OFF", localName: "MAINTENANCE_MODE_OFF"},
  ],
);

/**
 * @generated from message wavin.aqora.v2.PushDeviceSettingsCommand
 */
export const PushDeviceSettingsCommand = proto3.makeMessageType(
  "wavin.aqora.v2.PushDeviceSettingsCommand",
  [],
);

/**
 * @generated from message wavin.aqora.v2.DeviceSpecificCommand
 */
export const DeviceSpecificCommand = proto3.makeMessageType(
  "wavin.aqora.v2.DeviceSpecificCommand",
  () => [
      {no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */},
      {no: 2, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "payload"},
      {no: 3, name: "number", kind: "scalar", T: 2 /* ScalarType.FLOAT */, oneof: "payload"},
  ],
);

/**
 * @generated from message wavin.aqora.v2.SetPumpCommand
 */
export const SetPumpCommand = proto3.makeMessageType(
  "wavin.aqora.v2.SetPumpCommand",
  () => [
      {no: 1, name: "on_off", kind: "scalar", T: 8 /* ScalarType.BOOL */, oneof: "action"},
      {no: 2, name: "percentage", kind: "scalar", T: 2 /* ScalarType.FLOAT */, oneof: "action"},
      {no: 3, name: "flow", kind: "scalar", T: 2 /* ScalarType.FLOAT */, oneof: "action"},
  ],
);

